export var version = '3.3.7';
//# sourceMappingURL=version.js.map